import { getLocaleText } from '@/pages/home/components/RegionSelect/locale'
import React from 'react'

import * as styles from './noSearchData.module.less'

interface NoSearchDataProps {
  text?: string | undefined
}

const NoSearchData = (props: NoSearchDataProps) => {
  const { text } = props
  return (
    <div className={styles['container']}>
      <span>{text || getLocaleText('no_data')}</span>
    </div>
  )
}

export default NoSearchData